import { useState } from "react";
import deployment from "../Assests/kioskImage/kiosk_deployment_img.png";
import dropDown from '../Assests/kioskImage/dropDown.png'
const Sixth = () => {
  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleQuestion = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };
  return (
    <>
      <div className="deployment-container ">
        <p >
          AI Kiosk deployment as an integral component of the IEEE Smart Village
          Symposium 2024
        </p>
        <p >
          Bringing Digital Transformation to Rural Villages with Accessible
          Technology Solutions, Empowering Local Communities. A Special Thanks
          to E-Hands for Enabling This Opportunity and Advancing Smart
          Technology for Sustainable Communities.
        </p>
        <img src={deployment} alt="Deployment" />

      </div>
      <section className="faq">
        <div className="faq-container">
          <p>Frequently asked Questions?</p>
          {[
            {
              title: "What is an AI kiosk and how does it work?",
              content: "An AI kiosk is an interactive, self-service station powered by artificial intelligence. It uses algorithms to understand user input and provide personalized responses or actions"
            }, {
              title:" What kind of tasks can I use the AI kiosk for?",
              content:"The AI kiosk can analyze various health metrics such as oximeter readings, blood pressure, body composition, Prakriti & Vikriti Assessment. Based on these assessments, it provides personalized recommendations, including dietary suggestions, recipes, lifestyle practices, and herbal supplements."
            }, 
            {
              title: "Is my personal data safe when I use this AI kiosk?",
              content: " Yes, the kiosk is designed with privacy and security in mind. Any personal information you provide is handled according to strict data protection protocols, and sensitive data is encrypted to prevent unauthorized access. However, it's always a good idea to check the privacy policy available on the kiosk for more details about data usage and storage"
            },
            {
              title: " Can I book an teleconsultation with the AI kiosk?",
              content: "Yes, the AI kiosk allows you to easily book a teleconsultation with a healthcare professional. After completing your health assessments, you can schedule a consultation directly through the kiosk for personalized advice and guidance"
            },
            {
              title:" What should I do if the AI kiosk isn't working properly?",
              content:"Send a mail to conact@ayurai.io"
            }, 
            
            
          ].map((question, index) => (
            <div
              key={index}
              className={`faq-item ${activeQuestion === index ? 'active' : ''}`}
              onClick={() => toggleQuestion(index)}
            >
              <h3>
                {question.title}
                <img
                  src={dropDown} // Replace with the actual path to your image
                  alt="Dropdown Icon"
                  className="dropdown-icon-new"
                />
              </h3>
              <div className="faq-answer">
                {question.content}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
export default Sixth;
